import { render } from "./DeliveryBoyModal.vue?vue&type=template&id=1872d6f2"
import script from "./DeliveryBoyModal.vue?vue&type=script&lang=js"
export * from "./DeliveryBoyModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__